/** @tsxImportSource @emotion/react */
/**
 * @author andy.an@bybit.com
 */
'use client';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { cn } from "../../../lib/utils";
import { CheckIcon } from '@bfe/moly-icons';
import React, { useLayoutEffect, useState } from 'react';
import { molyBoxedSelectCompact } from "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BoxedSelect = function BoxedSelect(props) {
  var children = props.children,
    isSelected = props.isSelected,
    className = props.className,
    disabled = props.disabled,
    onChange = props.onChange;
  var handleClick = function handleClick() {
    // disabled时点击无效
    if (!disabled) {
      onChange === null || onChange === void 0 || onChange();
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    onClick: handleClick,
    className: cn(className, molyBoxedSelectCompact, 'card', "".concat(isSelected ? 'isSelectedCard' : ''), "".concat(!isSelected ? 'isNotSelectedCard' : ''), "".concat(disabled ? 'isDisabledCard' : '')),
    children: [children, /*#__PURE__*/_jsxs("div", {
      className: "tag",
      children: [/*#__PURE__*/_jsx("div", {
        className: "tagBg"
      }), /*#__PURE__*/_jsx(CheckIcon, {
        className: "icon"
      })]
    })]
  });
};
var BoxedSelectGroup = function BoxedSelectGroup(props) {
  var children = props.children,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? '' : _props$defaultValue,
    _props$value = props.value,
    value = _props$value === void 0 ? '' : _props$value,
    onChange = props.onChange;
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    selectedValue = _useState2[0],
    setSelectedValue = _useState2[1];
  var handleChange = function handleChange(newValue) {
    // 不存在value则说明为非受控模式，需要手动设置内部值
    if (!value) {
      setSelectedValue(newValue);
    }
    if (onChange) {
      onChange(newValue === selectedValue ? '' : newValue);
    }
  };

  // 当传入value后，需要映射到内部selectedValue上，因为组件以selectedValue为准
  useLayoutEffect(function () {
    setSelectedValue(value);
  }, [value]);
  return /*#__PURE__*/_jsx("div", {
    children: React.Children.map(children, function (child) {
      return /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, {
        isSelected: child.props.value === selectedValue,
        onChange: function onChange() {
          return handleChange(child.props.value);
        }
      }) : child;
    })
  });
};
BoxedSelect.Group = BoxedSelectGroup;
export default BoxedSelect;